import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ERTUserService } from "../../../services/ert-user/ert-user.service";
import { Kr998ErtUsersService } from "../../../services/kr998ErtUsers/kr998ErtUsers.service";
import { LoggedUserService } from "../../../services/common/logged-user.service";
import { ERTUser } from "../../../interfaces/ert-user/ert-user";
import { Ikr998ErtUsers } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998ertusers";

@Component({
  selector: "app-ert-add-additional-user",
  templateUrl: "./ert-add-additional-user.component.html"
})
export class ErtAddAdditionalUserComponent implements OnInit {
  users: ERTUser[] = [];
  instructors: ERTUser[] = [];
  selectedUserId: number | null = null;
  selectedInstructorId: number | null = null;
  krId: number = 0;
  isInvalidSelection: boolean = false;

  constructor(
    private userService: ERTUserService,
    private kr998ErtUsers: Kr998ErtUsersService,
    private route: ActivatedRoute,
    private router: Router,
    private loggedUserService: LoggedUserService
  ) {}

  ngOnInit() {
    this.krId = +this.route.snapshot.paramMap.get("id")!;

    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      const facilityId = Number(user?.facilityId) || 1;
      this.userService.getUsersAndInstructors(facilityId).subscribe((data) => {
        this.users = data.users
          .filter(
            (user) =>
              !user.picklistValues.some(
                (picklist) => picklist.value === "Inactive"
              )
          )
          .sort((a, b) => a.lastName.localeCompare(b.lastName));
        this.instructors = data.instructors
          .filter(
            (user) =>
              !user.picklistValues.some(
                (picklist) => picklist.value === "Inactive"
              )
          )
          .sort((a, b) => a.lastName.localeCompare(b.lastName));
      });
    });
  }

  addUserOrInstructor() {
    const userId = this.selectedUserId ?? 0;
    const instructorId = this.selectedInstructorId ?? 0;

    this.isInvalidSelection =
      (userId === 0 && instructorId === 0) || (userId > 0 && instructorId > 0);

    if (this.isInvalidSelection) {
      return;
    }
    const selectedId =
      userId > 0 ? userId : instructorId > 0 ? instructorId : null;
    if (!selectedId) {
      return;
    }

    const isInstructor = instructorId > 0;

    const data: Ikr998ErtUsers[] = [
      {
        kr998DetailsId: 0,
        userErtId: selectedId,
        kr998Id: this.krId,
        isInstructior: isInstructor,
        instructorAtTimeOfClass: false,
        createdDate: null,
        hours: 0,
        attendanceType: 0,
        attendanceStatus: 1,
        userErt: null,
        kr998: null,
      },
    ];
    this.kr998ErtUsers.createKr998ErtUsers(data).subscribe({
      next: () => {
        this.router.navigate(["/ert-kr998/ert-kr998-view", this.krId]);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  onCancel(): void {
    this.router.navigate(["/ert-kr998/ert-kr998-view", this.krId]);
  }
}
